import { Input, Text } from '@viapeople/components'
import { type DataFeedColumnMappingFormSlice, hasManagerColumnMapping } from './dataFeedColumnMapping'

const managerColumnFields = [
	{
		key: 'primaryManagerId',
		label: 'Primary Manager ID Column',
		placeholder: 'e.g. Manager ID (optional)',
		hint: "The column containing the direct manager's external user ID.",
	},
	{
		key: 'highLevelManagerId',
		label: 'Secondary Manager ID Column',
		placeholder: 'e.g. Secondary Manager ID (optional)',
		hint: 'A second-level (skip-level) manager. Leave unmapped to skip.',
	},
	{
		key: 'coManagerIds',
		label: 'Co-Manager IDs Column',
		placeholder: 'e.g. Co-Manager IDs (optional)',
		hint: 'Comma-separated external IDs of peer managers who share responsibility.',
	},
] as const

export function DataFeedColumnMappingFields({
	description,
	values,
	onChange,
}: {
	description: string
	values: DataFeedColumnMappingFormSlice
	onChange: (patch: Partial<DataFeedColumnMappingFormSlice>) => void
}) {
	const shouldShowHierarchyWarning = hasManagerColumnMapping(values)

	return (
		<>
			<Text variant='medium' weight='semibold' className='mt-6'>
				Column Mapping
			</Text>
			<Text variant='small' className='text-neutral-600'>
				{description}
			</Text>

			<Input
				label='First Name Column'
				value={values.firstName}
				onChange={(e) => onChange({ firstName: e.target.value })}
				placeholder='First Name'
				isRequired
			/>

			<Input
				label='Last Name Column'
				value={values.lastName}
				onChange={(e) => onChange({ lastName: e.target.value })}
				placeholder='Last Name'
				isRequired
			/>

			<Input
				label='Email Column'
				value={values.email}
				onChange={(e) => onChange({ email: e.target.value })}
				placeholder='Email'
				isRequired
			/>

			<Input
				label='External ID Column'
				value={values.externalId}
				onChange={(e) => onChange({ externalId: e.target.value })}
				placeholder='External ID'
				isRequired
			/>

			{managerColumnFields.map((field) => (
				<Input
					key={field.key}
					label={field.label}
					value={values[field.key]}
					onChange={(e) => onChange({ [field.key]: e.target.value })}
					placeholder={field.placeholder}
					hint={field.hint}
				/>
			))}

			{shouldShowHierarchyWarning && (
				<Text variant='hint' className='text-warning-700'>
					Mapping manager columns makes this data feed the source of truth for organization hierarchy on the next
					polling run.
				</Text>
			)}

			<Input
				label='Deleted Indicator Column'
				value={values.deletedIndicator}
				onChange={(e) => onChange({ deletedIndicator: e.target.value })}
				placeholder='e.g. Status (optional)'
			/>
		</>
	)
}
